import { useEffect } from "react";
import { useRouter } from "next/router";
import Image from "next/image";
import { withAuthUser } from "next-firebase-auth";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useAuth } from "@/components/auth/hooks/useAuth";
import { useTranslation } from "next-i18next";
// BOOTSTRAP
import { Accordion } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
// COMPONENTS
import BootstrapSpinner from "@/components/elements/LoadingPlaceholders/BootstrapSpinner";
import ServiceClientsToggle from "@/components/elements/AccordionsToggles/ServiceClientsToggle";
import SideLinks from "@/components/core/CustomerService/SideLinks/SideLinks";
// LOGOS
import BRT_Logo from "@/public/static/courierLogos/BRT_Logo.svg";
import DHL_Logo from "@/public/static/courierLogos/DHL_Logo.svg";
import DPD_Logo from "@/public/static/courierLogos/DPD_Logo.svg";
import TNT_Logo from "@/public/static/courierLogos/TNT_Logo.svg";
import { NextSeo } from "next-seo";

const accordionItems = [
  {
    title: "shipping",
    menuItems: [
      {
        id: 0,
        title: "",
        text: "Spediamo in tutta Europa",
      },
    ],
  },
  {
    title: "shipping-fees",
    menuItems: [
      {
        id: 0,
        title: "",
        text: "Le spedizioni in Europa hanno un costo fisso di 30 € e in Svizzera 50 €. Le spedizioni in Italia hanno un costo fisso di 20 €.",
      },
    ],
  },
  {
    title: "couriers",
    menuItems: [
      {
        id: 0,
        title: "",
        text: "",
        logo: [BRT_Logo, DHL_Logo, DPD_Logo, TNT_Logo],
      },
    ],
  },
  {
    title: "pickup",
    menuItems: [
      {
        id: 0,
        title: "",
        text: "Puoi sempre ordinare e decidere di ritirare personalmente presso il nostro punto vendita.",
      },
    ],
  },
];

function Delivery() {
  const auth = useAuth();
  const router = useRouter();

  const { t } = useTranslation("delivery");

  // If the user is not allowed will be redirect to homepage.
  useEffect(() => {
    if (auth.isUserSupplier()) {
      router.push("/home-supplier");
    }
  }, [[], auth]);

  return auth.isUserSupplier() ? (
    <BootstrapSpinner />
  ) : (
    <Container fluid className="px-0">
      <NextSeo
        title={t("delivery")}
        description={""}
        openGraph={{
          type: "website",
          title: t("delivery"),
          description: "",
          url: `${process.env.NEXT_PUBLIC_BASE_URL}/delivery`,
        }}
      />
      <Row key="catalogPage" className="mx-0 px-3">
        <SideLinks />
        <Col className="px-0 px-lg-5" style={{ maxWidth: "80rem" }}>
          <h1 className="fs-1 fw-semibold text-center text-md-start text-uppercase pb-5">{t("delivery")}</h1>
          <p>{t("subtitle")}</p>
          <div className="pt-1">
            {accordionItems.map((accordionItem, index) => (
              <div className="py-2" key={index}>
                <Accordion>
                  <ServiceClientsToggle className="text-uppercase" eventKey="0" title={t(`${accordionItem.title}.title`)} />
                  <Accordion.Collapse eventKey="0">
                    <div className="d-flex align-items-center bg-white px-3 pb-3">
                      {accordionItem.menuItems.map((menuItem, index) => (
                        <div key={index}>
                          <p>
                            <span className="text-uppercase">{t(`${accordionItem.title}.menuItems.${index}.title`)}</span>
                            <span>{t(`${accordionItem.title}.menuItems.${index}.text`)}</span>
                          </p>
                          {menuItem.logo &&
                            menuItem.logo.map((logo, index) => (
                              <div key={index} className="justify-content-center position-relative m-4" style={{ height: "5rem", width: "15rem" }}>
                                <Image unoptimized src={logo} layout="fill" objectFit="contain" alt={`courier_${index}`} />
                              </div>
                            ))}
                        </div>
                      ))}
                    </div>
                  </Accordion.Collapse>
                </Accordion>
              </div>
            ))}
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common", "header", "footer", "delivery", "services-side-links", "db-translations"])),
    },
  };
}

export default withAuthUser({})(Delivery);
